import React from 'react'
import Profile from 'src/app/Profile/Profile'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import ProfileApiKeysAppRoute from 'src/navigation/appRoutes/profile/profileApiKeys.appRoute'
import ProfileDeleteAppRoute from 'src/navigation/appRoutes/profile/profileDelete.appRoute'
import ProfileInfoAppRoute from 'src/navigation/appRoutes/profile/profileInfo.appRoute'
import ProfileNotificationsAppRoute from 'src/navigation/appRoutes/profile/profileNotifications.appRoute'
import ProfileOverviewAppRoute from 'src/navigation/appRoutes/profile/profileOverview.appRoute'
import ProfileSecurityAppRoute from 'src/navigation/appRoutes/profile/profileSecurity.appRoute'
import { profileRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const ProfileAppRoute: AppRoute = {
  id: AppLocation.Profile,
  routeProps: profileRouteProps,
  component: <Profile />,
  subRoutes: [
    ProfileOverviewAppRoute,
    ProfileInfoAppRoute,
    ProfileNotificationsAppRoute,
    ProfileDeleteAppRoute,
    ProfileSecurityAppRoute,
    ProfileApiKeysAppRoute,
  ],
  meta: { contentType: SidenavContentType.Main },
}

export default ProfileAppRoute
